import clsx from 'clsx';
import type * as React from 'react';

import { Image, Pressable } from '@gitbook/spine-react';

/**
 * Grid of selectable images.
 */
export function ImagesGrid(props: { children: React.ReactNode }) {
    const { children } = props;

    return <div className="grid grid-cols-1 gap-4 md:grid-cols-3">{children}</div>;
}

/**
 * Item in an image grid.
 */
export function ImageGridItem(props: {
    /** Source of the image to display */
    src: string;

    /** Callback when the image is pressed. */
    onPress: () => void;

    /** Control button to display in the top right corner */
    button?: React.ReactNode;

    /** True if the item is considered selected */
    selected?: boolean;

    /** Text to describe the image */
    children: React.ReactNode;
}) {
    const { src, onPress, button, selected = false, children } = props;

    return (
        <div className="group/imageitem flex flex-col">
            <Pressable onPress={onPress}>
                <div className="relative aspect-video overflow-hidden rounded-md outline outline-2 outline-transparent outline-offset-2 hover:outline-[--sp-color-text-primary]">
                    <Image
                        src={src}
                        resize={{ fit: 'cover', width: 156 }}
                        className="aspect-[2/3] size-full object-cover"
                    />

                    {button ? (
                        <div
                            className={clsx(
                                'absolute top-0 right-0 p-2 group-hover/imageitem:visible',
                                selected ? 'visible' : 'invisible'
                            )}
                        >
                            {button}
                        </div>
                    ) : null}
                </div>
            </Pressable>
            <div className="mt-2 max-w-[8.875rem]">
                <p className="hyphens-auto text-muted text-ui-small">{children}</p>
            </div>
        </div>
    );
}
